import Swiper from './swiper.vue';
import Slide from './slide.vue';

export {
    Swiper, Slide
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-swiper-component/index.js
// module id = 224
// module chunks = 0